(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.blackbird = {
    attach: function (context, settings) {
      function focusKeyDown(e) {
        if ([9, 13, 32, 38, 40].indexOf(e.keyCode) !== -1) {
          $('body').addClass('keyboard-activated');
          $(window).on('mousedown.keyboard', focusMouseDown);
          $(window).off('keydown.keyboard');
        }
      }

      function focusMouseDown(e) {
        $('body').removeClass('keyboard-activated');
        $(window).on('keydown.keyboard', focusKeyDown);
        $(window).off('mousedown.keyboard');
      }

      $(window).on('keydown.keyboard', focusKeyDown);

      // Remove all svg IDs.
      $('svg').removeAttr('id');

      // Toggle class on body for if modal is open.
      $(window).on({
        'dialog:aftercreate': function (dialog, $element, settings) {
          $('body').addClass('ui-dialog-open');
        },
        'dialog:afterclose': function (dialog, $element, settings) {
          $('body').removeClass('ui-dialog-open');
        }
      });
    }
  };

  Drupal.behaviors.scrollIn = {
    attach: function (context, settings) {
      $(once('animate-items', 'body', context)).each(function (index) {
        const mediaItems = [].slice.call(document.querySelectorAll('[data-animate="fade-in"]'));
        let imageObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              let animateImage = entry.target;
              animateImage.classList.add('in-viewport');
              imageObserver.unobserve(animateImage);
            }
          });
        });
        mediaItems.forEach(function (animateImage) {
          imageObserver.observe(animateImage);
        });

        const titlesToAnimate = [].slice.call(document.querySelectorAll('[data-animate="highlight"]'));
        let titleObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              let animateTitle = entry.target;
              animateTitle.classList.add('in-viewport');
              titleObserver.unobserve(animateTitle);
            }
          });
        });
        titlesToAnimate.forEach(function (animateTitle) {
          titleObserver.observe(animateTitle);
        });


      });
    }
  };

  // Use the empty Emplifi Chat block in block layout as an attachment
  // point to instantiate Emplifi Chat.
  // The block's custom [data-emplifi-chat] attribute is the best method as it's decoupled
  // from the block's ID and is less likely to change.
  Drupal.behaviors.initEmplifiChatBlock = {
    attach: function (context, settings) {
      const blocks = once('js-once-emplifichatblock', '[data-emplifi-chat], #block-emplifichatblock', context);

      // The block wrapper and its inner element can both match
      // Guard at the document level to load chat only once per page.
      if (!blocks.length || !once('js-once-emplifichat-init', 'html').length) {
        return;
      }

      // Prefer the channel ID delivered on the block's attribute, falling back
      // to drupalSettings, then to the non-production channel.
      let channelId = 'TkG4rK66UCP3z50F5oqpMA';
      let channelElement = null;

      // loop through the blocks to find the first one with a channel ID attribute
      blocks.some(function (block) {
        channelElement = block.matches('[data-emplifi-channel-id]')
          ? block
          : block.querySelector('[data-emplifi-channel-id]');
        return channelElement !== null;
      });

      // If we found a block with a channel ID attribute, use it.
      // Otherwise, check drupalSettings.
      if (channelElement && channelElement.getAttribute('data-emplifi-channel-id')) {
        channelId = channelElement.getAttribute('data-emplifi-channel-id');
      }
      else if (settings && settings.emplifiChat && typeof settings.emplifiChat.channelId === 'string') {
        channelId = settings.emplifiChat.channelId;
      }

      // Set the channel ID on the global window object
      // used by the Emplifi script
      window.astuteBotMessengerSettings = {
        channelId: channelId
      };

      // load Emplifi initialization script
      const emplifiScript = document.createElement('script');
      emplifiScript.src = '/themes/custom/butterball/js/emplifichat.js';
      document.head.appendChild(emplifiScript);
    }
  };

  Drupal.behaviors.startMessengerChat = {
    attach: function (context, settings) {
      once('js-once-start-messenger-chat', 'a.start-messenger-chat').forEach(
        function (trigger) {
          trigger.addEventListener('click', function (event) {
            event.preventDefault();
            startMessengerChat();
          });
        }
      );
    }
  };

  Drupal.behaviors.headerAccesbility = {
    desktopAccessibility: function () {
      const tabKey = 'Tab';
      const enterKey = 'Enter';
      let mainNavLinks = '';
      let lastUtilityMenuLink = $('#block-utility-menu').find('a:last');
      mainNavLinks = $("ul[data-region='header'] .top-level-menu-item.menu-item--expanded");
      let firstFocusableContentLink = $('.node__content').find('a:first');
      $('.region-header').find('.site-logo').on('keydown', function (e) {
        if ($(this).is(':focus')) {
          switch (e.key) {
            case tabKey:
              e.preventDefault();
              if (e.shiftKey) {
                $('.top-line--wrapper').attr('style', '');
                $('.region-header').attr('style', '');
                $('.region-header__content').attr('style', '');
                $('.region-header__content .block-system-branding-block__content img').attr('style', '');
                $('html').attr('style', '');
                lastUtilityMenuLink.focus();
              }
              else {
                $('#block-butterball-main-menu').find('a:first').parent().find('.menu-item__button').focus().addClass('focus');
                $('#block-butterball-main-menu').find('a:first').parent().find('.menu-item__button-expand').css('display', 'inline');
                $('#block-butterball-main-menu').find('a:first').css('display', 'none');
              }
              break;
          }
        }
      });
      mainNavLinks.each(function (index) {
        let mainNavLink = $(this);
        let menuName = $(this).find('a:first').text();
        let dropdownMenu = $(this).find('.menu-dropdown-0');
        let firstDropDownMenuLink = dropdownMenu.find('a:first');
        var btn = $('<button class="menu-item__button top-level-menu-item-button-' + index + '"><span class="menu-item__button-expand">Expand ' + menuName + '</span><span class="menu-item__button-collapse">Collapse ' + menuName + '</span></button>');
        $(this).append(btn);
        // Menu Link
        $(this).find('a:first').on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if (e.shiftKey) {
                  if ($(this).parent().prev().hasClass('menu-item')) {
                    e.preventDefault();
                    $(this).parent().prev().find('.menu-item__button').focus().addClass('focus');
                    $(this).parent().prev().find('.menu-item__button-expand').css('display', 'inline');
                    $(this).parent().prev().find('a:first').css('display', 'none');
                  }
                }
                else {
                  e.preventDefault();
                  $(this).parent().find('.top-level-menu-item-button-' + index).focus().addClass('focus');
                  $(this).css('display', 'none');
                  $(this).parent().find('.menu-item__button-expand').css('display', 'inline');
                  if ($(this).parent().prev().hasClass('menu-item')) {
                    $(this).parent().prev().css('display', 'inline');
                  }
                }
                break;
            }
          }
        });
        // Btn is focused
        $(btn).on('focus', function () {
          $(this).on('keydown', function (e) {
            if ($(this).is(':focus')) {
              switch (e.key) {
                case enterKey:
                  e.preventDefault();
                  if (dropdownMenu.attr('style') === '') {
                    mainNavLink.find('a:first').trigger('mouseleave');
                    btn.find('.menu-item__button-expand').css('display', 'inline');
                    btn.find('.menu-item__button-collapse').css('display', 'none');
                  }
                  else {
                    mainNavLink.find('a:first').trigger('mouseover');
                    btn.find('.menu-item__button-expand').css('display', 'none');
                    btn.find('.menu-item__button-collapse').css('display', 'inline');
                  }
                  break;
                case tabKey:
                  if (e.shiftKey) {
                    e.preventDefault();
                    btn.removeClass('focus');
                    btn.find('.menu-item__button-expand').css('display', 'none');
                    btn.find('.menu-item__button-collapse').css('display', 'none');
                    $(this).parent().find('a:first').css('display', 'inline');
                    $(this).parent().find('a:first').focus();
                    mainNavLink.find('a:first').trigger('mouseleave');
                  }
                  else {
                    if (dropdownMenu.attr('style') === '') {
                      e.preventDefault();
                      dropdownMenu.find('a:first').focus();
                    }
                    else {
                      btn.removeClass('focus');
                      $(this).parent().find('a:first').css('display', 'inline');
                      btn.find('.menu-item__button-expand').css('display', 'none');
                      btn.find('.menu-item__button-collapse').css('display', 'none');
                    }
                  }
                  break;
              }
              return;
            }
          });
        });
        firstDropDownMenuLink.on('focus', function (e) {
          $(this).on('keydown', function (e) {
            if ($(this).is(':focus')) {
              switch (e.key) {
                case tabKey:
                  if (e.shiftKey) {
                    e.preventDefault();
                    btn.focus();
                    mainNavLink.find('a:first').trigger('mouseleave');
                  }
                  break;
              }
              return;
            }
          });
        });
      });
      var nonDropdownLinks = $("ul[data-region='header'] .top-level-menu-item:not(.menu-item--expanded)").find('a:first');
      nonDropdownLinks.each(function (index) {
        $(this).on('keydown', function (e) {
          if ($(this).is(':focus')) {
            if ($(this).parent().prev().hasClass('menu-item--expanded')) {
              switch (e.key) {
                case tabKey:
                  if (e.shiftKey) {
                    e.preventDefault();
                    $(this).parent().prev().find('.menu-item__button').focus().addClass('focus');
                    $(this).parent().prev().find('.menu-item__button-expand').css('display', 'inline');
                    $(this).parent().prev().find('a:first').css('display', 'none');
                  }
                  break;
              }
            }
            else {
              switch (e.key) {
                case tabKey:
                  if ($(this).hasClass('search__icon')) {
                    if (e.shiftKey) {
                      e.preventDefault();
                      $(this).parent().prev().find('a:first').focus();
                    }
                    else {
                      e.preventDefault();
                      firstFocusableContentLink.focus();
                    }
                  }
                  break;
              }
            }
          }
        });
      });
      firstFocusableContentLink.on('keydown', function (e) {
        if ($(this).is(':focus')) {
          switch (e.key) {
            case tabKey:
              if (e.shiftKey) {
                e.preventDefault();
                $("ul[data-region='header'] .top-level-menu-item").find('.search__icon').focus();
              }
              break;
          }
        }
      });
    },
    mobileAccessibility: function () {
      const tabKey = 'Tab';
      const enterKey = 'Enter';
      let mainNavLinks = '';
      mainNavLinks = $("ul[data-region='mobile_menu'] .top-level-menu-item.menu-item");
      let firstMenuLink = $("ul[data-region='mobile_menu']").find('a:first');
      let openMenuLink = $('.hamburger--menu-container-icon__open');
      let closeMenuLink = $('.hamburger--menu-container-icon__close');
      let mainMenu = $("ul[data-region='mobile_menu']");
      let lastUtilityMenuLink = $('#block-utility-menu').find('a:last');
      let firstFocusableContentLink = $('.node__content').find('a:first');
      $('.region-header').find('.site-logo').on('keydown', function (e) {
        if ($(this).is(':focus')) {
          switch (e.key) {
            case tabKey:
              if (e.shiftKey) {
                e.preventDefault();
                $('.skip-link').focus();
              }
              else {
                e.preventDefault();
                $('.hamburger--menu-container-icon.is-active').focus();
              }
              break;
          }
        }
      });
      $('.hamburger--menu-container-icon__open').on('focus', function (e) {
        $(this).on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case enterKey:
                e.preventDefault();
                openMenuLink.trigger('click');
                firstMenuLink.focus();
                break;
              case tabKey:
                e.preventDefault();
                if (e.shiftKey) {
                  $('#block-butterball-site-branding').find('a:first').focus();
                }
                else {
                  firstFocusableContentLink.focus();
                }
                break;
            }
          }
        });
      });
      $('.hamburger--menu-container-icon__close').on('focus', function (e) {
        $(this).on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case enterKey:
                e.preventDefault();
                closeMenuLink.trigger('click');
                $(this).prev().focus();
                break;
            }
          }
        });
      });
      mainNavLinks.each(function (index) {
        let firstMenuLink = mainMenu.find('li:first').find('a:first');
        // Menu Link
        $(this).find('a:first').on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if (e.shiftKey) {
                  if ($(this).attr('data-drupal-link-system-path') === firstMenuLink.attr('data-drupal-link-system-path')) {
                    e.preventDefault();
                    closeMenuLink.focus();
                  }
                  else {
                    e.preventDefault();
                    $(this).parent().prev().find('a:first').focus();
                  }
                }
                else {
                  e.preventDefault();
                  if ($(this).hasClass('search__icon')) {
                    $('#block-utility').find('a:first').focus();
                  }
                  else {
                    $(this).parent().next().find('a:first').focus();
                  }
                }
                break;
              case enterKey:
                $(this).trigger('click');
                var subNavDropdown = $(this).parent().find('.menu-dropdown-0');
                subNavDropdown.find('a:first').focus();
                if ($('li.menu-parenttitle').length) {
                  let subNavTitleLinks = $('li.menu-parenttitle');
                  subNavTitleLinks.each(function (index) {
                    // eslint-disable-next-line
                    $(this).find('a:first').on('keydown', function (e) {
                      if ($(this).is(':focus')) {
                        switch (e.key) {
                          case tabKey:
                            if (e.shiftKey) {
                              e.preventDefault();
                              $(this).parent().find('.mm-back').trigger('click');
                              $(this).closest('.top-level-menu-item').find('a:first').focus();
                            }
                            break;
                        }
                      }
                    });
                  });
                }
                break;
            }
          }
        });

      });
      let subNavTitleLinks = $('li.menu-parenttitle');
      subNavTitleLinks.each(function (index) {
        $(this).find('a:first').on('keydown', function (e) {
          if ($(this).is(':focus')) {
            switch (e.key) {
              case tabKey:
                if (e.shiftKey) {
                  e.preventDefault();
                  $(this).parent().find('.mm-back').trigger('click');
                  $(this).closest('.top-level-menu-item').find('a:first').focus();
                }
                break;
            }
          }
        });
      });
      let linksToWatch = $("ul[data-region='mobile_menu']").find('a');
      linksToWatch.on('click', function () {
        if ($('ul.menu-level-expanded').length) {
          var subNavDropdownLinks = $('ul.menu-level-expanded').find('a');
          subNavDropdownLinks.each(function (index) {
            $(this).on('keydown', function (e) {
              if ($(this).is(':focus')) {
                switch (e.key) {
                  case tabKey:
                    // Last List Item
                    // What menu level are we on?
                    if (!$(this).parent().next().length) {
                      if (($(this).parent().is(':last-child') &&
                        $(this).closest('.menu-level-2').length &&
                        $(this).closest('.menu-item--expanded').is(':last-child')
                      ) || (
                        $(this).parent().hasClass('last-item') &&
                        !$(this).closest('menu-level-1').nextAll('.menu').length &&
                        !$(this).parent().hasClass('menu-item--expanded'))) {
                        $(this).closest('ul.menu-level-1').find('.menu-parenttitle').find('a:first').focus();
                      }
                    }
                    break;
                }
              }
            });
          });
        }
      });
      lastUtilityMenuLink.on('keydown', function (e) {
        if ($(this).is(':focus')) {
          switch (e.key) {
            case tabKey:
              if (e.shiftKey) {
                e.preventDefault();
                $(this).parent().prev().find('a:first').focus();
              }
              else {
                e.preventDefault();
                closeMenuLink.trigger('click');
                firstFocusableContentLink.focus();
              }
              break;
          }
        }
      });
      firstFocusableContentLink.on('keydown', function (e) {
        if ($(this).is(':focus')) {
          switch (e.key) {
            case tabKey:
              if (e.shiftKey) {
                e.preventDefault();
                openMenuLink.focus();
              }
              break;
          }
        }
      });
    },
    attach: function (context, settings) {
      $(once('header-accessibility', 'body', context)).each(function (index) {
        $(window).on('resize', function (e) {
          if ($('.region-header').find(document.activeElement).length) {
            document.activeElement.blur();
          }

          if (window.matchMedia('(min-width:1023px)').matches) {
            if ($('.menu-item__button').length) {
              $('.top-level-menu-item').find('a:first').attr('style', '');
              $('.menu-item__button').remove();
            }
            Drupal.behaviors.headerAccesbility.desktopAccessibility();
          }
          else {
            Drupal.behaviors.headerAccesbility.mobileAccessibility();
          }
        });
        if (window.matchMedia('(min-width:1023px)').matches) {
          Drupal.behaviors.headerAccesbility.desktopAccessibility();
        }
        else {
          Drupal.behaviors.headerAccesbility.mobileAccessibility();
        }
      });
    }
  };
})(jQuery, Drupal);
